// These are used to try to get search engines to prioritize
// more recently published documentation (i.e. we hope docs for the latest
// version of QLab gets put up at the top).
export const DOC_FRONTMATTER_DEFAULTS_BY_VERSION = [
  {
    version: 1,
    publishedOnForSEO: '2006-09-01',
  },
  {
    version: 2,
    publishedOnForSEO: '2009-01-01',
  },
  {
    version: 3,
    publishedOnForSEO: '2013-01-01',
  },
  {
    version: 4,
    publishedOnForSEO: '2016-11-16',
  },
  {
    version: 5,
    publishedOnForSEO: '2022-08-30',
    updatedOnForSEO: '2024-06-11',
  },
];
